<template>
    <div ref="breadcrumb" class="breadcrumb" data-cy="breadcrumb">
        <ul class="breadcrumb__list" :class="{ multilevel: items.length > 1, lastHide: lastHide }">
            <li class="breadcrumb__item breadcrumb__item--active">
                <a href="/" tabindex="-1" class="breadcrumb__link" :title="$t('mainTitle')">
                    <i class="ico ico--home"></i>
                </a>
            </li>

            <template v-for="(item, index) in items" :key="index">
                <li v-if="item.title !== productName" class="breadcrumb__item">
                    <i class="breadcrumb__arrow"></i>
                    <nuxt-link v-if="item.url" :to="item.url" class="breadcrumb__link" data-cy="breadcrumb-link">{{
                        item.title
                    }}</nuxt-link>
                    <span v-else class="breadcrumb__name">{{ item.title }}</span>
                </li>
            </template>
        </ul>
    </div>
</template>
<script lang="ts">
import BreadcrumbItem from '~/models/BreadcrumbItem'

export default {
    props: {
        items: {
            type: Array as PropType<BreadcrumbItem[]>,
            required: true,
        },
        lastHide: {
            type: Boolean,
            default: false,
        },
        productName: {
            type: String,
            default: '',
        },
    },
    mounted() {
        setTimeout(() => {
            this.scrollBreadcrumb()
        }, 0)
    },
    methods: {
        scrollBreadcrumb() {
            if (!this.$refs.breadcrumb) {
                return
            }

            this.$refs.breadcrumb.scrollTo({
                left: 1000,
                behavior: 'auto',
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.breadcrumb {
    overflow-y: hidden;
    overflow-x: auto;
    width: calc(100% + 30px);
    margin-left: -15px;
    position: relative;
    margin-bottom: 1rem;
    margin-top: 1rem;
    padding: 0 15px;

    @media (max-width: 768px) {
        width: auto;
    }
}

.breadcrumb__list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    align-content: center;
}

.breadcrumb__item {
    display: flex;
    align-items: center;
    align-content: center;
}

.breadcrumb__item::before {
    display: none;
}

.breadcrumb__arrow {
    background: transparent url('/nuxt-assets/icons/breadcrumb-arrow.svg') no-repeat scroll 0 0;
    background-size: cover;
    width: 6px;
    height: 10px;
    display: inline-block;
    margin-left: 11px;
    margin-right: 11px;
}

.breadcrumb__link {
    font-size: 14px;
    line-height: 30px;
    color: #424242;
    text-decoration: underline;
    white-space: nowrap;

    &:hover {
        @media (min-width: 1024px) {
            text-decoration: none;
        }
    }

    .ico {
        margin: 3px 4px 0 0;
    }
}

.breadcrumb__name {
    color: #424242;
}
</style>
